:host {
  @include reset-host;
}

:host .article-section {
  @include wrapper;
  padding: rem(64) $gutter;
  overflow: clip;

  background: $white;

  @include mq('max', 'md') {
    padding: rem(50) $gutter-mobile;
  }

  // Layout
  .container {
    max-width: $max-width;
    margin: 0 auto;
  }

  // Elements
  .heading {
    margin-right: $gutter;
    margin-left: 0;

    font-weight: $fw-medium;
    font-size: $fs-4xl;
    line-height: 1;
    letter-spacing: -0.27px;

    @include mq('max', 'md') {
      margin-right: 0;
      margin-bottom: $gutter-mobile;

      font-size: $fs-2xl;
      text-align: center;
    }
  }

  .button {
    display: inline-block;
  }
}
